import { render } from "./HeaderOnboardingScreen.vue?vue&type=template&id=9d7a46c8&scoped=true"
import script from "./HeaderOnboardingScreen.vue?vue&type=script&lang=js"
export * from "./HeaderOnboardingScreen.vue?vue&type=script&lang=js"

import "./HeaderOnboardingScreen.vue?vue&type=style&index=0&id=9d7a46c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d7a46c8"]])

export default __exports__